var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ticimax-member-selector" }, [
    _c(
      "div",
      { staticClass: "left" },
      [
        _c("h3", [_vm._v(_vm._s(_vm.$t("message.filters")))]),
        _vm._v(" "),
        _vm._l(_vm.clone.groups, function (group, index) {
          return _c(
            "div",
            { key: group.id },
            [
              _c("FilterGroup", {
                attrs: {
                  "on-removed": _vm.onFilterGroupRemoved,
                  "show-remove-button": _vm.clone.groups.length > 1,
                },
                model: {
                  value: _vm.clone.groups[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.groups, index, $$v)
                  },
                  expression: "clone.groups[index]",
                },
              }),
              _vm._v(" "),
              _vm.clone.groups.length > 1 &&
              index !== _vm.clone.groups.length - 1
                ? _c("div", { staticClass: "filter-condition-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "filter-condition" },
                      [
                        _c(
                          "a-select",
                          {
                            class: { hovered: _vm.selectHovered },
                            attrs: { value: _vm.clone.operator },
                            on: {
                              change: function (op) {
                                return (_vm.clone.operator = op)
                              },
                              click: function (e) {
                                e.stopPropagation()
                              },
                              mouseenter: function () {
                                return (_vm.selectHovered = true)
                              },
                              mouseleave: function () {
                                return (_vm.selectHovered = false)
                              },
                            },
                          },
                          [
                            _c("a-select-option", { attrs: { value: "or" } }, [
                              _vm._v(_vm._s(_vm.$t("chatbotv2.or"))),
                            ]),
                            _vm._v(" "),
                            _c("a-select-option", { attrs: { value: "and" } }, [
                              _vm._v(" " + _vm._s(_vm.$t("chatbotv2.and"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "filter-add-group-wrapper" }, [
          _c(
            "div",
            {
              staticClass: "filter-add-group",
              on: { click: _vm.addFilterGroup },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.addFilterGroup")))]),
            ]
          ),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "right" },
      [
        _c(
          "div",
          { staticClass: "preview-title" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.$t("ticimax.examplePreview")))]),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { primary: true, disabled: _vm.downloading },
                on: { click: _vm.downloadAsFile },
              },
              [_vm._v(_vm._s(_vm.$t("message.excelDownload")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("ve-pagination", {
              attrs: {
                total: _vm.totalMembers,
                "page-index": _vm.cursor.page,
                "page-size": _vm.cursor.perPage,
                "page-size-option": [10, 15, 20, 50, 100],
              },
              on: {
                "on-page-number-change": function (val) {
                  return (_vm.cursor.page = val)
                },
                "on-page-size-change": function (val) {
                  return (_vm.cursor.perPage = val)
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("MembersTable", {
          attrs: {
            loading: _vm.loading,
            members: _vm.members,
            fullScreen: _vm.fullScreen,
            readonly: "",
          },
          model: {
            value: _vm.tableModel,
            callback: function ($$v) {
              _vm.tableModel = $$v
            },
            expression: "tableModel",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "filter-add-group-plus" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }